import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-organization-modal',
  standalone: false,
  templateUrl: './add-organization-modal.component.html',
  styleUrls: ['./add-organization-modal.component.sass']
})
export class AddOrganizationModalComponent implements OnInit {
  nameControl: FormControl;

  constructor(public dialogRef: MatDialogRef<AddOrganizationModalComponent>) {}

  ngOnInit(): void {
    this.nameControl = new FormControl('', [Validators.maxLength(50)]);
  }

  onSubmit() {
    this.dialogRef.close(this.nameControl.value);
  }
}
